
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";

import { ViewAnalytics } from "@/mixins";
import { LogService } from "@/services";
import { ApplicationModule, getStoreModule } from "@/store";
import { VignetteEndpoints } from "@/types";

@Component
export default class LoginRedirect extends mixins(ViewAnalytics) {
  applicationStore!: ApplicationModule;

  // Override for PageTitle mixin
  pageName = "Login";

  created(): void {
    this.applicationStore = getStoreModule(ApplicationModule, this.$store);
  }

  get loginUrl(): string {
    const baseOrigin = this.applicationStore.getBaseUrlOrigin;
    const redirectPath = encodeURIComponent(this.applicationStore.getRedirectPath);

    LogService.debug(`baseUrlOrigin: '${baseOrigin}', redirectPath: '${redirectPath}'`);

    // Add base origin and login page, append redirect url if it's set
    return (
      baseOrigin + VignetteEndpoints.LOGIN + (redirectPath != null && redirectPath != "" ? "?redr=" + redirectPath : "")
    );
  }

  mounted(): void {
    this.pushPageViewEvent();

    LogService.info(`Redirecting to '${this.loginUrl}'`);
    window.location.href = this.loginUrl;
  }
}
